import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import classNames from 'lib/util/classNames'
import styles from './GradientText.module.scss'

/**
 * The `GradientText`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function GradientText (props) {
  const { Tag, angle, children, className, color, ...rest } = props
  const classNameOutput = useMemo(
    () => classNames([className, styles.text, styles[`color-${color}`]]),
    [className, color]
  )
  const styleOutput = useMemo(
    () => ({
      '--angle': `${angle}deg`
    }),
    [angle]
  )

  return (
    <Tag className={classNameOutput} style={styleOutput} {...rest}>
      {children}
    </Tag>
  )
}

/** @type {object} */
GradientText.propTypes = {
  Tag: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  angle: PropTypes.number
}

/** @type {object} */
GradientText.defaultProps = {
  Tag: 'div',
  children: null,
  className: '',
  color: 'a',
  angle: 170
}

// Memoize
export default memo(GradientText)
